import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from '../selectors/users';

import { getSignature } from '../api/zoom-api';

import ZoomFrame from './zoom-frame';

const Zoom = ({ meetingId, password, currentUser, onLeave }) => {
    const [params, setParams] = useState(null);

    const handleLeave = () => {
        leave();
    }

    const leave = () => {
        setParams(null);
        onLeave && onLeave();
    }

    useEffect(() => {
        leave();

        if (!meetingId) {
            return;
        }

        getSignature(meetingId, 0).then(signature => {
            setParams({
                signature,
                userName: currentUser.name || currentUser.email,
                userEmail: currentUser.email,
                meetingId,
                password
            });
        });
    }, [meetingId]);

    return <ZoomFrame params={params} onLeave={handleLeave} />;
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();

    return ({ users }, ownProps) => {
        return {
            currentUser: getCurrentUser(users)
        }
    }
}

export default connect(makeMapStateToProps)(Zoom);
